import { isMobile } from "../common/utils";
import Swiper from "swiper";

const initialize = async (sectionData) => {
  const mobile = isMobile();
  const swiper = new Swiper(`#shopify-section-${sectionData.id} .gd-swiper`, {
    slidesPerView: 3,
    spaceBetween: 40,
    slidesOffsetBefore: 32,
    slidesOffsetAfter: 32,
    breakpoints: {
      0: {
        slidesPerView: 1.5,
        spaceBetween: 24,
      },
      801: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
    },
  });
};

/*
 * main
 */

document.addEventListener("DOMContentLoaded", () => {
  if (window.gd.template != "index" || !window.gd.sections) {
    return;
  }
  const sectionData = window.gd.sections.find((s) => s.type == "top-ranking");
  if (!sectionData) {
    return;
  }
  initialize(sectionData);
});
